import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Business from '@material-ui/icons/Business';
import ButtonBase from '@material-ui/core/ButtonBase';
import HelpOutlineRounded from '@material-ui/icons/HelpOutlineRounded';
import TrendingUpRounded from '@material-ui/icons/TrendingUpRounded';
import CloseRounded from '@material-ui/icons/CloseRounded';
import Component from '../../../Component';
import { withResizer, withTranslations } from '../../../../HoCs';
import styles from './styles';
import pages, { getRouteForPage } from '../../../../PageEnums';
import { path, merge } from '../../../../utils';
import OYO from '../../../../resources/vectors/oyo';
import IconButton from '../../../Button/Icon';
import view from '../../../../Enums';
import { earningPotentialEnabled } from '../../../../config/countryConfig';
import {Link} from 'react-router-dom';
import { extractPageAndCountryIsoCode } from '../../../../utils/functionUtils';

class Menu extends Component {

    state = {
        helpOpen: false,
    };

    styles = styles;
    staticMenuRoutes = [view.DESKTOP];

    isActive = route => {
        const [country_iso_code,pageKey] = extractPageAndCountryIsoCode(path(this.props.match, 'path', ''));
        return route.includes(pages[pageKey].route)
    };

    navigate = route => () => window.location = '/' + route;

    renderItem = (route, Icon, label, labelStyle) => <ButtonBase style={{ width: '100%' }}>
        <Link to={route} style={{...this.gs('item_wrapper'),...(this.isActive(route) ? this.gs('item_active') : {})}}><div style={{ ...this.gs('item') }}>
            {Icon && <Icon style={this.gs('item_icon')} />}
            <span style={merge(this.gs('item_label'), labelStyle)}>{label}</span>
        </div></Link>
    </ButtonBase>;

    toggleHelp = bool => () => this.setState({ helpOpen: bool });

    render = () => {
        const isStaticMode = this.staticMenuRoutes.includes(this.getViewMode());
        return <div style={{ ...this.gs('container'), ...this.props.style }}>
            <div style={this.gs('header')}>
                <OYO width={58} height={20} />
                <div style={this.gs('left_divider')} />
                <div style={this.gs('owner_portal')}>{this.guc('owner_portal')}</div>
                <IconButton onClick={this.props.onClose} size='small' style={{ marginRight: 11 }}><CloseRounded /></IconButton>
            </div>
            {this.renderItem(getRouteForPage(pages.PROPERTIES), Business, this.guc('Properties'))}
            {!isStaticMode && this.renderItem(getRouteForPage(pages.HELP), HelpOutlineRounded, this.guc('need_help')+'?')}
            {!isStaticMode && earningPotentialEnabled() && this.getWidth()<=600 && this.renderItem(pages.EARN.route, TrendingUpRounded, this.guc('how_much_can')+'?', { fontSize: 12 })}
        </div>;
    }
}

Menu.propTypes = {
    match: PropTypes.object.isRequired, // connected through withRouter
    styles: PropTypes.object,
    onClose: PropTypes.func,
};

export default withRouter(withResizer(withTranslations(Menu)));